export default "__VITE_ASSET__B1zOtK88__"